import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from '@keyslabor/shared/ui';
import {
  VIDEO_MIN_LENGTH,
  VIDEO_MAX_LENGTH,
} from '@/pages/Answers/constants.ts';
import {
  RecordControlButton,
  type RecordControlProps,
} from './RecordControlButton';

/**
 * Alternative control: no ring. While the recording is still under
 * VIDEO_MIN_LENGTH the button shows how many more seconds are required.
 */
export const RecordControlMinLabel: FC<RecordControlProps> = (props) => {
  const { isRecording, timeLeft } = props;
  const { t } = useTranslation();

  const elapsed = VIDEO_MAX_LENGTH - timeLeft;
  const minSecondsLeft = isRecording
    ? Math.max(0, VIDEO_MIN_LENGTH - elapsed)
    : 0;
  const isDisabled = isRecording && minSecondsLeft > 0;

  return (
    <div className="absolute -top-8">
      <RecordControlButton
        {...props}
        isDisabled={isDisabled}
        recordingLabel={
          minSecondsLeft > 0 ? (
            <Flex gap="0" flexDirection="column">
              <span>{t('record_button.stop')}</span>
              <span style={{ fontSize: '12px', fontWeight: 600, opacity: 0.85 }}>
                {t('record_status.min_duration', { count: minSecondsLeft })}
              </span>
            </Flex>
          ) : (
            <>{t('record_button.stop')}</>
          )
        }
      />
    </div>
  );
};

export default RecordControlMinLabel;
